import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=b2485a30&scoped=true"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=b2485a30&prod&lang=scss&scoped=true"
import style1 from "./SiteHeader.vue?vue&type=style&index=1&id=b2485a30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2485a30",
  null
  
)

export default component.exports